module.exports = __webpack_public_path__ + "img/howto_insurancestaking_createdstake.03df6911.png";